import styled from 'styled-components';
import { fontWeight, fontSize, spacing } from '../../common/theme/constants';
import ThemeColors from '../../common/theme/colors';
import KitForm from '../KitFormComponents/KitForm';

export const Styledlabel = styled.label`
  display: block;
  margin-left: ${spacing.absolute.s}px;
  margin-bottom: 0;
  color: ${ThemeColors.gray_50};
  font-size: ${fontSize.text_14}rem;
`;

export const StyledCountryCode = styled.div`
  width: 150px;
`;

export const Fieldset = styled(KitForm.FieldSet)`
  & > legend {
    font-weight: ${fontWeight.normal};
  }
`;
